
import { LoadingButton } from '@mui/lab';
import { Button, CircularProgress, Dialog, DialogContent, DialogTitle, FormHelperText, Input, MenuItem, Select, Stack, Table, TableBody, TableCell, TableRow, Typography } from '@mui/material';
import React from 'react';
import { deleteRequest, getRequest, postRequest } from 'utils/apiRequest';

import DeleteTwoToneIcon from '@mui/icons-material/DeleteTwoTone';
import EditTwoToneIcon from '@mui/icons-material/EditTwoTone';
import { Box } from '@mui/system';
import { Formik } from 'formik';
import * as Yup from 'yup';

import Accordion from '@mui/material/Accordion';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import { ProductFulfillmentModal } from './ProductFulfillmentModals';
import Image from 'components/Image';


export const ProductEditModal = ({ product, warehouses, carriers }) => {
    const [dialogOpen, setDialogOpen] = React.useState(false);

    const handleWarehouseLocations = (prod) => {
        // setProduct(prod);
        setDialogOpen(true);
    }
    const handleDialogClose = () => {
        setDialogOpen(false);
    }
    const button = <Button onClick={() => handleWarehouseLocations(product)} variant="outlined"><EditTwoToneIcon /></Button>
    return <>
        {button}
        <Dialog
            open={dialogOpen}
            onClose={handleDialogClose}
        >
            <DialogTitle>Edit: {product.name}</DialogTitle>
            <DialogContent>
                <WarehouseLocations 
                        product={product} 
                        warehouses={warehouses} 
                        carriers={carriers} />
            </DialogContent>
        </Dialog>
    </>;
}


const WarehouseLocations = (props) => {
    const { warehouses, carriers } = props;
    const [productInventory, setProductInventory] = React.useState([]);
    const [missingWarehouses, setMissingWarehouses] = React.useState([]);
    const [loading, setLoading] = React.useState(true);
    const [product, setProduct] = React.useState(props.product);
    let aw = warehouses;
    React.useEffect(() => {
        getProductWarehouses();
    }, []);
    const getProductWarehouses = () => {
        const productInventories = [];
        const productWarehouseIds = [];
        return getRequest('/account/product/' + product.id).then((d) => {
            if (d.inventory) {
                d.inventory.forEach((inv, i) => {
                    productInventories.push(inv);
                    productWarehouseIds.push(inv.warehouse.id);
                })
                aw = aw.filter((wh, i)=> productWarehouseIds.indexOf(wh.id) === -1);
                setMissingWarehouses(aw)
                setProductInventory(productInventories)
                setLoading(false)
            }
        })
    }
    const fetchProduct = () => {
        return getRequest('/account/product/'+product.id).then((d) => {
           setProduct(d);
           getProductWarehouses();
        })
    };



    return (loading ? (
        <Box textAlign="center">
            <CircularProgress />
        </Box>
    )
        : (<>
            <Box>
                <Box display="grid" gap={1} gridTemplateColumns={'1fr 4fr'} marginBottom={'1rem'}>
                    <Image src={product.image_url} width={75} height={75} />
                    <Box>
                        <Typography variant="subtitle1">Name: {product.name}</Typography>
                        {product.sku && <Typography variant="subtitle1">Sku: {product.sku}</Typography>}
                        {product.upc && <Typography variant="subtitle1">UPC: {product.upc}</Typography>}
                    </Box>
                </Box>
                <Box fullWidth borderTop={'1px solid #ccc'}>
                    <InventoryTable 
                        inventory={productInventory} 
                        warehouses={warehouses} 
                        carriers={carriers}
                        product={product}
                        afterSave={()=>fetchProduct()} />
                </Box>
            </Box>
        </>))
}
const InventoryTable = ({ inventory, warehouses, carriers, product, afterSave = () => { return; } }) => {
    const rowMarkup = {};

    warehouses.forEach((warehouse, index) => {
        rowMarkup[warehouse.id] = (<TableRow id={warehouse.id} key={warehouse.id} position={index}>
            <TableCell>{warehouse.name}</TableCell>
            <TableCell>--</TableCell>
            <TableCell>--</TableCell>
            <TableCell>--</TableCell>
            <TableCell>--</TableCell>
            <TableCell>
                <ProductFulfillmentModal 
                        product={product} 
                        carriers={carriers} 
                        warehouses={warehouses} 
                        warehouse={warehouse}
                        fulfillmentLatencyHours={0}
                        carrierType={'Parcel'}
                        pickupTime={'17:00'}
                        afterSave={() => {return afterSave()}} />
            </TableCell>
        </TableRow>)
    });

    {
        inventory.forEach(({ id, carrier_type, fulfillment_latency_hours, warehouse, warehouse_carrier }, index) => {
            const days = Math.floor(fulfillment_latency_hours / 24);
            const fulfillmentText = days < 1 ? fulfillment_latency_hours + ' hours' : days + ' days';
            rowMarkup[warehouse.id] = <TableRow
                key={id}
                sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
            >
                <TableCell component="th" scope="row">{warehouse.name}</TableCell>
                <TableCell align="right">{warehouse_carrier.account_carrier.carrier.name}</TableCell>
                <TableCell align="right">{carrier_type}</TableCell>
                <TableCell align="right">{fulfillmentText}</TableCell>
                <TableCell align="right">{warehouse_carrier.pickup_time.substring(0, 5)}</TableCell>
                <TableCell>
                    <ProductFulfillmentModal 
                            product={product} 
                            carriers={carriers} 
                            warehouses={warehouses} 
                            warehouse={warehouse}
                            fulfillmentLatencyHours={fulfillment_latency_hours}
                            carrierType={carrier_type}
                            pickupTime={warehouse_carrier.pickup_time}
                            afterSave={() => {return afterSave()}}
                             />
                </TableCell>
            </TableRow>
        })
    }
    return <TableContainer>
        <Table sx={{ minWidth: 650 }} size="small" aria-label="a dense table">
            <TableHead>
                <TableRow>
                    <TableCell>Warehouse</TableCell>
                    <TableCell align="right">Carrier</TableCell>
                    <TableCell align="right">Carrier Type</TableCell>
                    <TableCell align="right">Fulfillment Delay</TableCell>
                    <TableCell align="right">Pickup Time</TableCell>
                </TableRow>
            </TableHead>
            <TableBody>
                {Object.values(rowMarkup)}
            </TableBody>
        </Table>
    </TableContainer>
}


const InventoryLatencySchema = Yup.object().shape({
    fulfillmentLatencyHours: Yup.number().min(0).required('Fulfillment Latency is required'),
    inventoryId: Yup.number().min(0).required('Inventory Id is required'),
    carrierType: Yup.string().oneOf(['Parcel', 'Freight', 'Van', 'Driver']).required('Type is required')
})
const InventoryEdit = ({ inventory, id, warehouseCarriers, onDelete = () => { return; } }) => {
    const [success, setSuccess] = React.useState(false);
    const [mounted, setMounted] = React.useState(false);
    React.useEffect(() => {
        setMounted(true);
        return () => {
            setMounted(false);
        }
    })
    return (<Formik
        initialValues={{
            fulfillmentLatencyHours: inventory.fulfillment_latency_hours,
            inventoryId: inventory.id,
            carrierId: inventory.account_warehouse_carrier_id,
            carrierType: inventory.carrier_type,
        }}
        validationSchema={InventoryLatencySchema}
        onSubmit={(values, { setErrors, setStatus, setSubmitting }) => {
            setSuccess(false);
            setSubmitting(true);
            let formData = new FormData();
            Object.keys(values).forEach((k) => {
                formData.append(k, values[k]);
            })
            postRequest('/account/product/inventory/update', formData).then(d => {
                if (d.errors) {
                    const err = {}
                    Object.keys(d.errors).forEach((k) => {
                        err[k] = d.errors[k][0];
                    })
                    setErrors(err);
                } else {
                    setSuccess(true);
                    setTimeout(() => {
                        if (mounted) {
                            setSuccess(false);
                        }
                    }, 3000)
                }
            }).catch(err => {
                console.log(err)
            }).finally(() => {
                setSubmitting(false);
            })
        }}>
        {({ errors, handleBlur, handleChange, handleSubmit, isSubmitting, touched, values }) => (

            <Accordion>
                <AccordionSummary
                    // expandIcon={<ExpandMoreIcon />}
                    aria-controls={"warehouse-" + inventory.id + "-content"}
                    id={"warehouse-" + inventory.id + "-header"}
                    sx={{ background: '#090637', color: 'white' }}
                >
                    <Typography sx={{ fontWeight: 'bold' }}>{inventory.warehouse.name}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <form noValidate onSubmit={handleSubmit}>
                        <Table sx={{ p: 1 }}>
                            <TableBody>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Fulfillment Latency (hours)</TableCell>
                                    <TableCell>
                                        <Input name="fulfillmentLatencyHours" type="text" value={values.fulfillmentLatencyHours} onChange={handleChange} sx={{ width: 120 }} />
                                        {touched.fulfillmentLatencyHours && errors.fulfillmentLatencyHours && (
                                            <FormHelperText error>
                                                {errors.fulfillmentLatencyHours}
                                            </FormHelperText>
                                        )}
                                        <Input name="inventoryId" type="hidden" value={values.inventoryId} onChange={handleChange} />
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Carrier</TableCell>
                                    <TableCell>
                                        <Select
                                            value={values.carrierId}
                                            name="carrierId"
                                            label="Carrier"
                                            sx={{ width: 120 }}
                                            onChange={handleChange}
                                        >
                                            {warehouseCarriers.map((c, i) => {
                                                return <MenuItem value={c.account_carrier_id} key={i}>{c.account_carrier.carrier.name}</MenuItem>
                                            })}
                                        </Select>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell sx={{ fontWeight: 'bold' }}>Package Type</TableCell>
                                    <TableCell>
                                        <Select
                                            value={values.carrierType}
                                            name="carrierType"
                                            label="Type"
                                            sx={{ width: 120 }}
                                            onChange={handleChange}
                                        >
                                            <MenuItem value="Parcel">Parcel</MenuItem>
                                            <MenuItem value="Freight">Freight</MenuItem>
                                            <MenuItem value="Van">Van</MenuItem>
                                            <MenuItem value="Driver">Driver</MenuItem>
                                        </Select>
                                    </TableCell>
                                </TableRow>
                                <TableRow>
                                    <TableCell align="left">
                                        <DeleteTwoToneIcon color="error" onClick={() => onDelete()} />
                                    </TableCell>
                                    <TableCell>
                                        <Stack direction="row" spacing={1}>
                                            <LoadingButton
                                                fullWidth
                                                disableElevation
                                                disabled={isSubmitting}
                                                size="small"
                                                type="submit"
                                                variant="contained"
                                                color={success ? "success" : "primary"}
                                                loading={isSubmitting}
                                            >{success ? "Saved" : "Submit"}
                                            </LoadingButton>
                                        </Stack>
                                    </TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </form>
                </AccordionDetails>
            </Accordion>
        )}
    </Formik>)
}